<div [ngClass]="rarity">
  {{ rarity }}
</div>
